import { defineStore } from "pinia";
import { ApiClient } from "@/api-client";
import { i18n } from "@/locales/index";
import { LoginClient } from "@/login-client/index.js";
import { useApplicationStore } from "./index";

export const useUserStore = defineStore("userStore", {
  state: () => ({
    user: null as User,
    loadingState: "unset" as loadingStateType,
    failedReason: "",
  }),
  actions: {
    async initUserAuthentication() {
      // set state
      this.loadingState = "loading";

      //get user instance
      const loginClient = LoginClient.getInstance();
      let user;
      try {
        user = await loginClient.getUser();
      } catch (error) {
        // handle error
        this.loadingState = "failed";
        this.failedReason = i18n.global.t("app.user.loadingData.error");
        useApplicationStore().addAlert({
          type: "Alert",
          key: "app.user.loadingData.error",
          keyData: {
            message: error instanceof Error ? error.message : String(error),
          },
        });
        return;
      }

      //set token
      const apiClient = ApiClient.getInstance();
      apiClient.setBearerToken(user.access_token);

      //set user from response
      this.user = {
        name: String(user.profile.name),
        email: String(user.profile.email),
      };
      this.loadingState = "success";

      // handle events
      loginClient.onSilentRenewError((error: Error) => {
        useApplicationStore().addAlert({
          type: "Alert",
          key: "app.user.loadingData.renewError",
          keyData: {
            message: error.message,
          },
        });
      });
    },
  },
});
